// @ts-nocheck
import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';

@Component({
	selector: 'lbca-input-boolean',
	templateUrl: './input-boolean.component.html',
	styleUrl: './input-boolean.component.scss',
})
export class InputBooleanComponent {
	public isDisabled: boolean = false;

	@ViewChild('inputToogler', { static: true }) inputToogler!: ElementRef<HTMLInputElement>;

	@Input() set value(val: boolean) {
		this.inputToogler!.nativeElement.checked = val;
	}

	@Input() set disabled(disabled: boolean) {
		this.isDisabled = disabled;
	}
	@Output() changeValue = new EventEmitter<any>();

	constructor() {}

	checkItem() {
		this.inputToogler!.nativeElement.checked = !this.inputToogler!.nativeElement.checked;
		this.changeValue.emit(this.inputToogler!.nativeElement.checked);
	}
}
